module.exports = __webpack_public_path__ + "static/westrock-logo-c873cf11ae06793c94c03fe75c902f23.png";